{
  "expandButtonOpen": "Vis mindre",
  "expandButtonClose": "Vis mer"
}
